import { ChangeEvent } from "react";

import { TextInput } from "@mantine/core";
import { QuestionnaireValidateReady } from "types";

type QuestionnaireShortTextProps = {
  data: QuestionnaireValidateReady;
  group: string;
  onChange: (response: string | string[], id: string, group: string, loading?: boolean, error?: string) => void;
  submitted?: boolean;
};

const QuestionnaireShortText = ({ data, group, onChange, submitted }: QuestionnaireShortTextProps) => {
  return (
    <TextInput
      value={data?.response as string}
      label={data.question}
      error={data.error}
      readOnly={submitted}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value, data.id, group)}
      required={data.required}
      maxLength={50}
      maw="50%"
      placeholder="Enter your response"
    />
  );
};

export default QuestionnaireShortText;
